module.exports = __webpack_public_path__ + "static/img/news4.be3871f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/news4.png
// module id = ighg
// module chunks = 1